import { AbstractControl, UntypedFormGroup, ValidationErrors, ValidatorFn } from '@angular/forms';

// custom validator to check that two fields match
export const confimrPasswordValidator = (c1: string, c2: string): ValidatorFn => {
  return (formGroup: AbstractControl | UntypedFormGroup): null | { [key: string]: any } => {

    if (formGroup.get(c1)?.value !== formGroup.get(c2)?.value) {
      // set errors for c2 (confirmation input) input
      formGroup.get(c2)?.setErrors({ passwordMisMatch: true });

      // group level validatopn errors
      return {
        passwordMisMatch: true
      };
    }

    if (formGroup.get(c2)?.errors) {
      // if there are some errors already preserve them without marking them as null
      const { passwordMisMatch, ...errors } = formGroup.get(c2)?.errors as any;
      formGroup.get(c2)?.setErrors(Object.keys(errors).length === 0 ? null : errors);
    }

    return null;
  };
};
